import { CATEGORY_HIERARCHY } from '../constants/categories';
const getCategoryPath = (category) => {
  if (!category) return [];
  
  // Check if it's a main category
  if (CATEGORY_HIERARCHY[category]) {
    return [category];
  }

  // Look for the category in subcategories
  for (const [mainCat, data] of Object.entries(CATEGORY_HIERARCHY)) {
    for (const [subCat, items] of Object.entries(data.subcategories)) {
      if (subCat === category || items.includes(category)) {
        if (items.includes(category)) {
          return [mainCat, subCat, category];
        }
        return [mainCat, subCat];
      }
    }
  }

  return [category]; // Return single category if not found in hierarchy
};
// Auxiliary functions from LandingPage
const getSubcategories = (category) => {
    if (!category) return [];
    if (CATEGORY_HIERARCHY[category]) {
      return Object.keys(CATEGORY_HIERARCHY[category].subcategories);
    }
    return [];
  };

  const getLeafCategories = (mainCategory, subCategory) => {
    if (!mainCategory || !subCategory) return [];
    return CATEGORY_HIERARCHY[mainCategory]?.subcategories[subCategory] || [];
  };

  const getAllCategories = (mainCategory) => {
    if (!mainCategory) return [];
    const categoryData = CATEGORY_HIERARCHY[mainCategory];
    if (!categoryData || !categoryData.subcategories) return [];

    return getSubcategories(mainCategory).flatMap(sub => {
      // Get leaf categories for this subcategory
      const leafCategories = getLeafCategories(mainCategory, sub);
      // Return both the subcategory and its leaf categories
      return [sub, ...leafCategories];
    });
  };

export { getSubcategories, getLeafCategories, getAllCategories, getCategoryPath };